import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UserService } from '../../../../core/auth/_services';
import { CategoryService, ContactRelationshipsService } from '../../../../core/lists';
import { StringUtilsService } from '../../../../core/services/string-utils.service';
import { take } from 'rxjs/operators';
import { TemplateService } from '../../../../core/lists/_services/template.service';
import { GeneralAutocompleteComponent } from '../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { TagService } from '../../../../core/services/tag-service.service';
import { OfficesService } from '../../../../core/management';
import { TaskFilterService } from '../task-filter-utility.service';
import { Subscription } from 'rxjs';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
@Component({
  selector: 'kt-task-filter-button',
  templateUrl: './task-filter-button.component.html',
  styleUrls: ['./task-filter-button.component.scss'],
})
export class TaskFilterButtonComponent implements OnInit {
  showForm = false;
  @Input() isHidden;
  @Input() groupedByTeam;
  @Input() groupedByTemplate;
  @Input() groupedByTag;
  @Input() isCompleted;
  @Input() isCanceled;
  @Input() fromPatient;
  @Input() fromDoctor;
  minDueToDate: any;
  maxDueFromDate: any;
  minCreatedToDate: any;
  maxCreatedFromDate: any;
  FilterButtonForm: FormGroup;
  categoryList = [];
  progressOptions = ['PLANNED', 'WAITING', 'ON_HOLD', 'IN_PROGRESS'];
  priorityOptions = [
    { value: '', label: 'All Priority' },
    { value: 'HIGH', label: 'High Priority' },
    { value: 'MEDIUM', label: 'Medium Priority' },
    { value: 'LOW', label: 'Low Priority' },
  ];
  userAutocompleteCall = this.userService.searchUsers.bind(this.userService);
  entityAutocompleteCall = this.contactService.searchEntities.bind(this.contactService, {
    type: '',
  });
  @ViewChild('userAutocomplete', { static: true }) userAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('entityAutocomplete', { static: true })
  entityAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('templateAutocomplete', { static: true })
  templateAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('tagAutocomplete', { static: true }) tagAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('officeAutocomplete', { static: true })
  officeAutocomplete: GeneralAutocompleteComponent;
  @ViewChild('filterForm', { static: false }) filterForm: ElementRef;
  withOutTeamObject = { id: 0, name: 'Without Team' };
  getOfficeAutocomplete = this.officesService.searchOffices.bind(this.officesService);
  subscription: Subscription;
  isFiltered = false;
  filterCounter;
  disableTeamOptions = false;
  clickedOutside = false;
  constructor(
    private userService: UserService,
    private contactService: ContactRelationshipsService,
    public stringUtils: StringUtilsService,
    private categoryService: CategoryService,
    private template: TemplateService,
    private tag: TagService,
    private officesService: OfficesService,
    private taskFilterService: TaskFilterService,
  ) {}

  ngOnInit(): void {
    this.FilterButtonForm = new FormGroup({
      withFollowUp: new FormControl(this.taskFilterService.filterFormSubject.value.withFollowUp),
      dueDate: new FormGroup({
        fromDateDue: new FormControl(
          this.taskFilterService.filterFormSubject.value.dueDate.fromDateDue,
        ),
        toDateDue: new FormControl(
          this.taskFilterService.filterFormSubject.value.dueDate.toDateDue,
        ),
      }),
      createdDate: new FormGroup({
        fromDateCreated: new FormControl(
          this.taskFilterService.filterFormSubject.value.createdDate.fromDateCreated,
        ),
        toDateCreated: new FormControl(
          this.taskFilterService.filterFormSubject.value.createdDate.toDateCreated,
        ),
      }),
      user: new FormControl(this.taskFilterService.filterFormSubject.value.user),
      entity: new FormControl(
        this.fromPatient
          ? this.taskFilterService.initialFormValue.entity
          : this.taskFilterService.filterFormSubject.value.entity,
      ),
      team: new FormControl(
        this.groupedByTeam
          ? this.taskFilterService.initialFormValue.team
          : this.taskFilterService.filterFormSubject.value.team,
      ), // categoryID
      template: new FormControl(
        this.groupedByTemplate
          ? this.taskFilterService.initialFormValue.template
          : this.taskFilterService.filterFormSubject.value.template,
      ),
      tag: new FormControl(
        this.groupedByTag
          ? this.taskFilterService.initialFormValue.tag
          : this.taskFilterService.filterFormSubject.value.tag,
      ),
      priority: new FormControl(this.taskFilterService.filterFormSubject.value.priority),
      status: new FormControl(this.taskFilterService.filterFormSubject.value.status), // filterStatus
      office: new FormControl(this.taskFilterService.filterFormSubject.value.office),
    });
    this.categoryService
      .getCategories()
      .pipe(take(1))
      .subscribe((res) => {
        if (res) this.categoryList = [this.withOutTeamObject, ...res.data];
      });
    this.updateAutoCompleteValues();
    this.taskFilterService.updateFilterObject(this.FilterButtonForm.value);
    this.taskFilterService.filteredEmitter.subscribe((didFilter) => {
      this.isFiltered = didFilter;
    });
    this.taskFilterService.filterCounter.subscribe((count) => {
      this.filterCounter = count;
    });
  }

  toggleForm() {
    this.showForm = !this.showForm;
    this.clickedOutside = false;
    this.FilterButtonForm.setValue(this.taskFilterService.filterFormSubject.value);
    this.updateAutoCompleteValues();
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.showForm && this.filterForm && !this.filterForm.nativeElement.contains(event.target)) {
      this.clickedOutside = true;
    }
  }
  closeForm() {
    this.showForm = false;
  }
  onSubmit() {
    this.closeForm();
    this.taskFilterService.updateFilterObject(this.FilterButtonForm.value);
  }

  resetForm() {
    this.FilterButtonForm.reset(this.taskFilterService.initialFormValue);
    this.userAutocomplete.setValue(this.taskFilterService.initialFormValue.user);
    this.entityAutocomplete.setValue(this.taskFilterService.initialFormValue.entity);
    this.templateAutocomplete.setValue(this.taskFilterService.initialFormValue.template);
    this.tagAutocomplete.setValue(this.taskFilterService.initialFormValue.tag);
    this.officeAutocomplete.setValue(this.taskFilterService.initialFormValue.office);
    this.taskFilterService.isDefaultFilteredValue.next(true);
    this.minDueToDate = '';
    this.minCreatedToDate = '';
    this.maxDueFromDate = '';
    this.maxCreatedFromDate = '';
    this.disableTeamOptions = false;
  }
  setMinDueToDate(event: MatDatepickerInputEvent<any>) {
    this.minDueToDate = event.value;
  }
  setMaxDueFromDate(event: MatDatepickerInputEvent<any>) {
    this.maxDueFromDate = event.value;
  }
  setMinCreatedToDate(event: MatDatepickerInputEvent<any>) {
    this.minCreatedToDate = event.value;
  }
  setMaxCreatedFromDate(event: MatDatepickerInputEvent<any>) {
    this.maxCreatedFromDate = event.value;
  }
  handleTagChange(value: any) {
    this.FilterButtonForm.get('tag').setValue(value);
  }
  handleUserChange(value: any) {
    this.FilterButtonForm.get('user').setValue(value);
  }
  handleEntityChange(value: any) {
    this.FilterButtonForm.get('entity').setValue(value);
  }
  handleTemplateChange(value: any) {
    this.FilterButtonForm.get('template').setValue(value);
  }
  handleOfficeChange(value: any) {
    this.FilterButtonForm.get('office').setValue(value);
  }
  clearDueDateFilter() {
    this.FilterButtonForm.get('dueDate').reset(this.taskFilterService.initialFormValue.dueDate);
    this.minDueToDate = '';
    this.maxDueFromDate = '';
  }
  clearCreatedDateFilter() {
    this.FilterButtonForm.get('createdDate').reset(
      this.taskFilterService.initialFormValue.createdDate,
    );
    this.minCreatedToDate = '';
    this.maxCreatedFromDate = '';
  }
  loadTemplatesList(term) {
    return this.template.findTaskTemplates({ notAdditionalStep: true }, term);
  }
  loadTagsList(term) {
    return this.tag.tagsAutocomplete(term);
  }

  displayUsers(user) {
    let res = '';
    if (user) {
      res += user.fullName;
    }
    if (user && user.name) {
      res += '  ' + `<small class="text-muted">` + user.name + `</small>`;
    }
    return res;
  }

  displayUsersSelected(user) {
    let res = '';
    if (user) {
      res += user.fullName;
    }
    return res;
  }

  onTeamSelectionChange(event: any) {
    if (event.value[0]?.id === 0) {
      this.FilterButtonForm.get('team').setValue([this.withOutTeamObject]);
      this.disableTeamOptions = true;
    } else {
      this.disableTeamOptions = false;
    }
  }
  compareFn(t1: any, t2: any): boolean {
    return t1?.id === t2?.id;
  }

  displayTemplate(template) {
    let res = '';
    if (template) {
      res += template.name;
    }
    return res;
  }

  displayTemplateSelected(template) {
    let res = '';
    if (template) {
      res += template.name;
    }
    return res;
  }
  displayTag(tag) {
    let res = '';
    if (tag) {
      res += tag.name;
    }
    return res;
  }
  displayTagSelected(tag) {
    let res = '';
    if (tag) {
      res += tag.name;
    }
    return res;
  }
  getItemCssClassByStatus(status): string {
    switch (status) {
      case 'PLANNED':
        return 'warning';
      case 'IN_PROGRESS':
        return 'success';
      case 'DONE':
        return 'primary';
      case 'WAITING':
        return 'info';
      case 'ON_HOLD':
        return 'danger';
      case 'CANCELED':
        return 'Canceled';
    }
  }

  displayOffice(office) {
    let res = '';
    if (office) {
      res += office.name;
    }
    if (office && office.name) {
      res += '  ' + `<small class="text-muted">` + office.name + `</small>`;
    }
    return res;
  }

  displayOfficeSelected(office) {
    let res = '';
    if (office) {
      res += office.name;
    }
    return res;
  }
  updateAutoCompleteValues() {
    this.userAutocomplete?.setValue(this.taskFilterService.filterFormSubject.value.user);
    this.userAutocomplete?.updateValueAndValidity();

    this.entityAutocomplete?.setValue(this.taskFilterService.filterFormSubject.value.entity);
    this.entityAutocomplete?.updateValueAndValidity();

    this.templateAutocomplete?.setValue(this.taskFilterService.filterFormSubject.value.template);
    this.templateAutocomplete?.updateValueAndValidity();

    this.tagAutocomplete?.setValue(this.taskFilterService.filterFormSubject.value.tag);
    this.tagAutocomplete?.updateValueAndValidity();

    this.officeAutocomplete?.setValue(this.taskFilterService.filterFormSubject.value.office);
    this.officeAutocomplete?.updateValueAndValidity();
  }
}
